import { SideBarInterface } from './SideBarInterface';
import { optionMenu } from './MenuOtions';
import { AuthorizationOption } from '../../authorization/Authorization';

const AccessToMenuOtions = () => {

    let optionList: SideBarInterface[] = [...optionMenu];
    optionMenu.map((option: SideBarInterface) => {
        let authorization: boolean = AuthorizationOption(option.name || '') || !option.name;
        if (!authorization) {
            optionList = optionList.filter((el: SideBarInterface) => el.name !== option.name);
        }
        return option;
    });
    return optionList;
}

export default AccessToMenuOtions;
